import { StyleSheet } from 'react-native';
import colors, { appTheme } from '@/config/colors';

export const styles = StyleSheet.create({
  body: {
    flex: 1,
    padding: 10,
  },
  agreementBlockStyle: {
    borderWidth: 1,
    borderColor: colors.darkGrey,
    backgroundColor: colors.white,
  },
  flexRow: {
    flexDirection: 'row',
  },
  fontBold: {
    fontWeight: '700',
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  redFont: {
    color: colors.red,
  },
  greenFont: {
    color: appTheme.primary,
  },
  textError: {
    fontSize: 18,
    paddingTop: 10,
    color: colors.red,
  },
});
